<template>
  <div class="files-upload">
    <input 
      type="file" 
      id="uFile" 
      name="uFile" 
      style="display: none;" 
      @change="handleInputUpload($event)" 
    />
    <div class="upload-button" @click="handleSelectFile">
      <van-icon name="add-o" class="add-o" size="18px" />上传附件
    </div>
    <van-action-sheet
      v-model="showActionSheet"
      :actions="actionSheetActions"
      cancel-text="取消"
      @select="handleActionSelect"
    />
    <div class="file-list" v-if="fileList.length">
      <div class="file-item" v-for="(item,index) in fileList" :key="item.newFileName">
        <div style="display: flex;align-items: center;">
          <van-image
            v-if="handleFileIconOption(item.originalFilename).iconName === 'image-icon'"
            :width="handleFileIconOption(item.originalFilename).width"
            :height="handleFileIconOption(item.originalFilename).height"
            :src="item.url"
            style="margin-right: 20px;flex-shrink: 0;"
          >
            <template slot="loading">
              <van-image
                :width="handleFileIconOption(item.originalFilename).width"
                :height="handleFileIconOption(item.originalFilename).height"
                :src="require(`@/assets/image/filesIcon/${handleFileIconOption(item.originalFilename).iconName}.png`)"
              />
            </template>
            <template slot="error">
              <van-image
                :width="handleFileIconOption(item.originalFilename).width"
                :height="handleFileIconOption(item.originalFilename).height"
                :src="require(`@/assets/image/filesIcon/${handleFileIconOption(item.originalFilename).iconName}.png`)"
              />
            </template>
          </van-image>
          <van-image
            v-else
            :width="handleFileIconOption(item.originalFilename).width"
            :height="handleFileIconOption(item.originalFilename).height"
            :src="require(`@/assets/image/filesIcon/${handleFileIconOption(item.originalFilename).iconName}.png`)"
            style="margin-right: 20px;flex-shrink: 0;"
          />
          <div style="flex: 1;overflow: hidden;">
            <div style="display: flex;align-items: center;overflow: hidden;">
              <div style="flex: 1;overflow: hidden;display: flex;align-items: center;">
                <div class="file-name">{{ item.originalFilename.slice(0,item.originalFilename.lastIndexOf(".")) }}</div>
                <div class="file-name-suffix">{{ item.originalFilename.slice(item.originalFilename.lastIndexOf(".")) }}</div>
              </div>
              <div class="file-delete" @click="handleDelete(item,index)">删除</div>
            </div>
            <div class="file-size">{{ filesizeFormat(item.fileSize) }}</div>
          </div>
        </div>
        <div class="file-upload-time">{{ item.createTime || "" }}</div>
        <!-- <div style="display: flex;justify-content: space-between;align-items: center;">
          <div class="file-name">{{ item.originalFilename }}</div>
          <div class="file-delete" @click="handleDelete(item,index)">删除</div>
        </div>
        <div class="file-size">{{ item.fileSize }}</div> -->
      </div>
    </div>
    <div class="submit-button" @click="handleSubmit">完成</div>
  </div>
</template>

<script>
import { Uploader , Icon , Image as VanImage , ActionSheet } from 'vant';
import { upload } from "@/api/taskBar/addTaskFilesUpload/index.js";
export default {
  components:{
    [Uploader.name]:Uploader,
    [Icon.name]:Icon,
    [VanImage.name]:VanImage,
    [ActionSheet.name]:ActionSheet,
  },
  data(){
    return {
      showActionSheet: false,
      bridgeTimer: null,
      actionSheetActions: [
        { name: '从相册选择图片', type: 'image', sourceType: 'album' },
        { name: '拍照', type: 'image', sourceType: 'camera' },
        { name: '从相册选择视频', type: 'video', sourceType: 'album' },
        { name: '录制视频', type: 'video', sourceType: 'camera' },
        { name: '选择其他文件', type: 'other' },
      ],
      fileList:[
        // {
        //   "fileId": "20240226161441A001",
        //   "fileName": "2024/02/26/20240226161441A001.jpg",
        //   "fileType": "jpg",
        //   "url": "http://192.168.101.63:8080/profile/upload/2024/02/26/20240226161441A001.jpg",
        //   "createTime": "2024-02-26 16:14:41",
        //   "fileSize": 1102670,
        //   "originalFilename": "Screenshot_20240226_151307_com.ss.android.ugc.aweme.jpg"
        // }
      ],
      // 前端可回显文件格式
      fileSuffixList:[
        { iconName: "word-icon" , suffixList:["doc","docx"] , width: "36" , height: "40" },
        { iconName: "excel-icon" , suffixList:["xls","xlsx"] , width: "36" , height: "40" },  
        { iconName: "ppt-icon" , suffixList:["ppt","pptx"] , width: "36" , height: "40"},
        { iconName: "pdf-icon" , suffixList:["pdf"] , width: "39" , height: "40" },
        { iconName: "image-icon" , suffixList:["bmp","gif","ico","jpg","png","webp","heic","raw"] , width: "36" , height: "36" },
        { iconName: "video-icon" , suffixList:["mp4","flv","m3u8","rtmp","hls","rtsp","mov"] , width: "36" , height: "36" },
        { iconName: "audio-icon" , suffixList:["mp3"] , width:"33" , height: "40" },
        // { iconName: "unknown-icon" , suffixList:[] , width},
      ],
      // 后端限制文件格式
      backendSuffix:[
        // 图片
        "bmp", "gif", "jpg", "jpeg", "png", "raw",
        // Word Excel powerpoint
        "doc", "docx", "xls", "xlsx", "ppt", "pptx", "html", "htm", "txt", 
        // 压缩文件
        "rar", "zip", "gz", "bz2", 
        // 视频格式
        "mp4", "avi", "rmvb", "mov",
        // pdf
        "pdf"
      ],
      backendSuffixUpperCase:[],
      imageSuffixList: ["bmp", "gif", "jpg", "jpeg", "png", "raw"],
      videoSuffixList: ["mp4", "avi", "rmvb", "mov"],
    }
  },
  created(){
    // 兼容大写文件后缀
    this.fileSuffixList = this.fileSuffixList.map(fileItem=>({ ...fileItem , suffixList: this.handleToLocaleUpperCase(fileItem.suffixList) }));
    this.backendSuffixUpperCase = this.backendSuffix.map(item=>item.toLocaleUpperCase());
    this.registerBridgeCallbacks();
  },
  beforeDestroy(){
    this.clearBridgeTimer();
    window.handleCompressResult = null;
    window.handleCompressStatus = null;
  },
  methods:{
    handleToLocaleUpperCase(list){
      let newList = [];
      list.map(item => {
        newList.push(item);
        newList.push(item.toLocaleUpperCase());
      });
      return newList;
    },
    handleSubmit(){
      window.uni.postMessage({ data: "finish" });
      window.uni.navigateBack({ delta: 1 });
    },
    handleDelete(item,index){
      this.$dialog.confirm({
        message: `确定要删除"${item.originalFilename}"吗？`,
        allowHtml:false,
        confirmButtonColor:'#086CDE'
      }).then(()=>{
        this.fileList.splice(index,1);
        window.uni.postMessage({ data: this.fileList });
      })
    },
    handleSelectFile(){
      this.showActionSheet = true;
    },
    handleActionSelect(action){
      this.showActionSheet = false;
      if (action.type === 'other') {
        document.querySelector("#uFile").click();
      } else {
        this.sendBridgeMessage(action.type, action.sourceType);
      }
    },
    registerBridgeCallbacks(){
      const vm = this;
      window.handleCompressResult = function(jsonStr) {
        vm.clearBridgeTimer();
        try {
          const result = JSON.parse(jsonStr);
          vm.$loading.close();
          if (result.success) {
            vm.fileList.push(result.data);
            window.uni.postMessage({ data: vm.fileList });
          } else {
            vm.$toast({ message: result.msg || '上传失败', icon: 'fail' });
          }
        } catch(e) {
          vm.$loading.close();
          console.log("handleCompressResult parse error", e);
        }
      };
      window.handleCompressStatus = function(status) {
        vm.clearBridgeTimer();
        if (status === 'compressing') {
          vm.$loading.open('压缩中...');
        } else if (status === 'uploading') {
          vm.$loading.open('上传中...');
        } else if (status === 'cancelled') {
          vm.$loading.close();
        }
      };
    },
    sendBridgeMessage(type, sourceType){
      this.$loading.open('处理中...');
      // iOS WKWebView 不会为 iframe 自定义 scheme 触发原生拦截，改用 postMessage 通道
      window.uni.postMessage({
        data: {
          action: 'selectAndCompress',
          type: type,
          sourceType: sourceType || 'album'
        }
      });
      this.clearBridgeTimer();
      this.bridgeTimer = setTimeout(() => {
        this.bridgeTimer = null;
        this.$loading.close();
        this.$toast({ message: '操作超时，请重试', icon: 'fail' });
      }, 30000);
    },
    clearBridgeTimer(){
      if (this.bridgeTimer) {
        clearTimeout(this.bridgeTimer);
        this.bridgeTimer = null;
      }
    },
    isImageFile(suffix) {
      return this.imageSuffixList.some(s => s.toLowerCase() === suffix.toLowerCase());
    },
    isVideoFile(suffix) {
      return this.videoSuffixList.some(s => s.toLowerCase() === suffix.toLowerCase());
    },
    handleInputUpload(e){
      this.$loading.open();
      let file = e.target.files[0]
      if (!file) return this.$loading.close();
      let fileSuffixIndex = file.name.lastIndexOf(".");
      let fileSuffix = file.name.slice(fileSuffixIndex+1);
      console.log('handleInputUpload file',file)
      if(!this.backendSuffix.concat(this.backendSuffixUpperCase).includes(fileSuffix)) {
        this.$dialog.alert({
          message: `请上传[${this.backendSuffix}]格式文件`,
          allowHtml:false,
          confirmButtonColor:'#086CDE'
        });
        return this.$loading.close();
      }else if(file.size > 1024 * 1024 * 20) {
        this.$dialog.alert({
          message: `请上传小于20MB大小的文件`,
          allowHtml:false,
          confirmButtonColor:'#086CDE'
        });
        return this.$loading.close();
      }
      if (this.isImageFile(fileSuffix)) {
        const type = 'image';
        this.$loading.open('读取文件中...');
        const reader = new FileReader();
        reader.onload = () => {
          this.$loading.open('压缩中...');
          window.uni.postMessage({
            data: {
              action: 'compressAndUpload',
              type: type,
              base64: reader.result,
              fileName: file.name
            }
          });
          e.target.value = '';
        };
        reader.onerror = () => {
          console.log("FileReader error", reader.error);
          this.$loading.close();
          this.$toast({ message: '文件读取失败', icon: 'fail' });
          e.target.value = '';
        };
        reader.readAsDataURL(file);
        return;
      }
      let param = new FormData()
      param.append('file', file)
      upload(param)
      .then(res => {
        if(res.code !== 200) return this.$toast({message: res.msg ,icon:"fail"});
        this.fileList.push(res.data);
        window.uni.postMessage({ data: this.fileList });
      }).catch(err => {
        console.log("请求失败",JSON.stringify(err));
      }).finally(() => {
        this.$loading.close();
        e.target.value = '';
      })
    },
    filesizeFormat(size) {//把字节转换成正常文件大小
      if (!size) return "";
      var num = 1024.00; //byte
      if (size < num)
          return size + "B";
      if (size < Math.pow(num, 2))
          return (size / num).toFixed(2) + "KB"; //kb
      if (size < Math.pow(num, 3))
          return (size / Math.pow(num, 2)).toFixed(2) + "MB"; //M
      if (size < Math.pow(num, 4))
          return (size / Math.pow(num, 3)).toFixed(2) + "G"; //G
      return (size / Math.pow(num, 4)).toFixed(2) + "T"; //T
    },
    handleFileIconOption(fileName){
      let suffixIndex = fileName.lastIndexOf(".");
      let suffix = fileName.slice(suffixIndex+1);
      let suffixActive = this.fileSuffixList.find(item=>item.suffixList.includes(suffix));
      return suffixActive ? suffixActive : { iconName: "unknown-icon" , suffixList:[] , width: "36" , height: "40"};
      // return require(`@/assets/image/filesIcon/${suffixActive ? suffixActive.iconName : "unknown-icon"}.png`);
      // return require("@/assets/image/filesIcon/audio-icon.png")
    }
  }
}
</script>

<style scoped lang="scss">
  .files-upload {
    padding: 32px 0;
    .upload-button {
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #086CDE;
      // background: linear-gradient(180deg, #5EB0FF 0%, #086CDE 100%);
      margin-bottom: 16px;
      .add-o {
        margin-right: 8px;
        color: #086CDE;
        font-weight: bold;
      }
    }
    .file-list {
      background-color: #FFF;
      padding: 8px 12px;
      .file-item + .file-item {
        margin-top: 8px;
      }
      .file-item {
        border: 1px solid #EFEFEF;
        padding: 18px 16px 16px 16px;
        overflow: hidden;
        .file-name {
          font-size: 16px;
          line-height: 24px;
          color: #333;
          word-break: break-all;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .file-name-suffix {
          flex-shrink: 0;
          font-size: 16px;
          line-height: 24px;
          color: #333;
        }
        .file-delete {
          font-size: 12px;
          color: #DC3C33;
          line-height: 24px;
          flex-shrink: 0;
          margin-left: 16px;
          flex-shrink: 0;
        }
        .file-size {
          font-size: 12px;
          color: #A6B6C6;
          line-height: 20px;
        }
        .file-upload-time {
          font-size: 12px;
          line-height: 12px;
          color: #A6B6C6;
          margin-top: 16px;
        }
      }
    }
    .submit-button {
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #FFF;
      background: linear-gradient(180deg, #5EB0FF 0%, #086CDE 100%);
      margin-bottom: 16px;
      position: fixed;
      left: 0;
      right: 0;
      bottom: 42px;
      z-index: 1;
    }
  }
</style>